import {useCallback, useEffect, useRef, useState} from 'react'
import { DrawingManager, GoogleMap, LoadScript } from '@react-google-maps/api';
import darkMapStyle from './darkMapStyle'
import { MapModes } from '../../constants/general';

const libraries = ['drawing', 'geometry']

function MapView(props){
    const {mapMode, onMapModeChange} = props
    const [isPanDisabled, setIsPanDisabled] = useState(false)
    const prevMode = useRef(MapModes.SELECT_START);

    useEffect(() => {
        document.addEventListener("keydown", _disablePan, false);
        document.addEventListener("keyup", _disablePan, false);
        return () => {
            document.removeEventListener("keydown", _disablePan, false);
            document.removeEventListener("keyup", _disablePan, false);
        }
    }, [])

    useEffect(() => {
        prevMode.current = mapMode
    }, [mapMode])

    const _disablePan = (event) => {
        if(prevMode.current === MapModes.SELECT_MARKER){
            setIsPanDisabled(event.shiftKey)
        }
            
        // if(event.shiftKey){
        //     onMapModeChange(MapModes.SELECT_MARKER)
        // }
        // if(event.ctrlKey && prevMode.current === MapModes.ASSIGN_ROUTE){
        //     onMapModeChange(MapModes.NONE)
        // } else if(event.ctrlKey && prevMode.current === MapModes.NONE){
        //     onMapModeChange(MapModes.ASSIGN_ROUTE)
        // }
    }

    const onLoad = useCallback((map)=>{
        window.googleMapInstance = map
    }, [])

    return (
        
            <GoogleMap
                onLoad={onLoad}
                mapContainerStyle={{width:'100%', height:'100%'}}
                zoom={11}
                options={{
                    zoomControl: false,
                    fullscreenControl: false,
                    mapTypeControl: false,
                    clickableIcons: false,
                    styles: props.mapStyle === 'light'? null : darkMapStyle,
                    gestureHandling: isPanDisabled ? 'none': 'auto'
                }}
                onClick={props.onClick}
                {...props}
            >
                {props.children}
                <DrawingManager
                    drawingMode={isPanDisabled ? props.markerSelectionMode: null}
                    onOverlayComplete={props.onOverlayComplete}
                    options={{
                        drawingControl: false,
                        editable: true
                    }}
                />
            </GoogleMap>
    )
}

export default MapView
